export default function slicePosts(posts, sliceSizes) {
    if (sliceSizes.reduce((acc, item) => (acc = acc + item), 0) > posts.length) {
        console.error("Slicing not possible due to insufficient length of array");
        return [];
    }
    const result = [];
    let index = 0;
    for (let size of sliceSizes) {
        let slicedPart = posts.slice(index, index + size);
        if (size <= 0)
            slicedPart = [];
        else if (slicedPart.length === 1)
            slicedPart = slicedPart[0];
        result.push(slicedPart);
        if (size > 0) {
            index += size;
        }
    }
    return result;
}
